module.exports = __webpack_public_path__ + "static/img/mjfPurpose1.1db0283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mjfPurpose1.png
// module id = 56MI
// module chunks = 2